import { action, decorate } from 'mobx';

import { RouterState, RouterStore } from 'mobx-state-router';
import { routes, baseUrl          } from './Routes';

import { StoreToolTip             }  from './StoreToolTip'
import { StoreMenu                }  from './StoreMenu'

const notFound = new RouterState('notFound');

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                             Store                             ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

class Store {

    baseUrl = baseUrl;

    storeToolTip = new StoreToolTip ();
    menu         = new StoreMenu    ();
    
    routerStore  = new RouterStore(this, routes, notFound);

    largeurBandeau = 1073;

    /* --------------------------------------------------------------------- */
    /* Définition de l'indicateur de sélection des onglets du menu principal */
    /* --------------------------------------------------------------------- */

    definirSelectionOnglet (liAction='',liMenu=''){

        switch (liMenu)
        {

            default :     

                this.menu.listeOnglet = this.menu.listeOnglet.map(onglet=>{
                    onglet.afficher  = onglet.liAction === liAction ? true : onglet.defaut;
                    onglet.selection = onglet.liAction === liAction;
                    return {...onglet}
                });

                break;

        } // Traitement selon le menu à traiter

    }        

    /* ----------------------------------- */
    /* Traitement des événements des menus */
    /* ----------------------------------- */

    actionMenu (liAction){
 
        this.noPage = 1;
        
        switch(liAction)
        {
            case "accueil" : 
                this.routerStore.goTo("home");
                break;
            case "listetome" : 
                this.routerStore.goTo("listetome");
                break;
            case "carte" : 
                this.routerStore.goTo("carte");
                break;
            case "couverture" : 
                this.routerStore.goTo("couverture");
                break;
            case "genese" : 
                this.routerStore.goTo("genese");
                break;
            case "jdr" : 
                this.routerStore.goTo("jdr");
                break;
            case "livraison" : 
                this.routerStore.goTo("livraison");
                break;
            case "contact" : 
                this.routerStore.goTo("contact");
                break;

            default :
                break;
        }
    }        

    /* ------------------------------------- */
    /* Positionnement sur la page par défaut */
    /* ------------------------------------- */

    goHome(){        
        this.routerStore.goTo("home");
    }
    

} // Fin de la classe Store

/* -------------------------- */
/* Définition des observables */
/* -------------------------- */

decorate (Store, {
    definirSelectionOnglet : action,
    goHome                 : action
} )

/* ----------------------------------- */
/* Génération et renvoi d'une instance */
/* ----------------------------------- */

const store = new Store();

store.goHome();

export default store;
    


// WEBPACK FOOTER //
// ./src/donnees/store.js